import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../component/SnackbarContext";
import { handleLoginResponse } from "../../utils/handleLoginResponse";
import TydiiLoader from "../../tydiiLoader";

export default function OAuthSuccess() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [decodedToken, setDecodedToken] = useState(null);
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();



  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      const decoded = decodeJWT(token);
      setDecodedToken(decoded);
      handleLoginResponse({
        responseData: decoded,
        token: token,
        dispatch,
        navigate,
        showSnackbar,
      });
    }
  }, [location]);

  const decodeJWT = (token) => {
    try {
      const base64Url = token.split(".")[1]; 
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (err) {
      console.error("Failed to decode JWT", err);
      return null;
    }
  };

  return (
    <div className="h-[calc(100vh-100px)] flex items-center justify-center">
       <TydiiLoader />
    </div>
  );
}
